import { LinkProps } from "@tanstack/react-router";
import { AnyRouteMatch } from "@tanstack/router-core";

function createImageHead({
  ogImage = "https://i.imgur.com/3lAAxjr.png",
}: {
  ogImage?: string;
}) {
  return [
    {
      property: "og:image:alt",
      content: "Graze.social's feed editor interface",
    },
    { name: "twitter:image", content: ogImage },
    {
      name: "twitter:image:alt",
      content: "Graze.social's feed editor interface",
    },
  ];
}

export function createHead({
  title,
  description,
  ogTitle = title,
  ogImage: ogImageInitial = "/index.png",
  pathname,
  ogParams,
}: {
  title: string;
  description: string;
  ogTitle?: string;
  ogImage?: LinkProps["to"];
  pathname?: string;
  ogParams?: {
    feedId?: string | number;
    userId?: string | number;
    nodeId?: string | number;
    slug?: string;
  };
}): {
  meta: AnyRouteMatch["meta"];
} {
  let ogImage: string = ogImageInitial;

  if (ogParams) {
    Object.entries(ogParams).forEach(([key, value]) => {
      ogImage = ogImage.replace(`$${key}`, value.toString());
    });
  }

  return {
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { title },
      { property: "og:title", content: ogTitle },
      { property: "og:description", content: description },
      { property: "og:url", content: `https://www.graze.social${pathname}` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: ogImage },
      { property: "og:site_name", content: "Graze.social" },
      { property: "og:locale", content: "en_US" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: ogTitle },
      { name: "twitter:description", content: description },
      ...createImageHead({ ogImage }),
    ],
  };
}
